export default {
  lock() {
    document.body.classList.add("disable-global-scroll");
  },
  unlock() {
    document.body.classList.remove("disable-global-scroll");
  },
};
